module.exports = __webpack_public_path__ + "img/img-zhilian-s9-tuya.98752f32.png";